import { defineComponent as _defineComponent } from 'vue'
import { CounterStatusItem } from "@/types/CounterStatusItemInterface";
  import { LotStatus } from "@/enums/LotStatus";
  import { computed, ref, watch } from "vue";

  interface ProgressItem {
    color: string;
    text: string;
    value: number;
  }

  interface Props {
    statusCounts: CounterStatusItem[];
  }
  
export default /*@__PURE__*/_defineComponent({
  __name: 'DashboardLots',
  props: {
    statusCounts: {}
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

  const props = __props;
  const defaultObject = {
    "Not Released": {
      color: "#595983",
      count: 0,
    },
    Available: {
      color: "#2CCD3C",
      count: 0,
    },
    EOI: {
      color: "#455cfc",
      count: 0,
    },
    "Contract Executed": {
      color: "#FEB520",
      count: 0,
    },
    Unconditional: {
      color: "#8f00ff",
      count: 0,
    },
    Settled: {
      color: "#F12B5B",
      count: 0,
    },
    Option: {
      color: "#FB7634",
      count: 0,
    },
    Offline: {
      color: "#C4C4C4",
      count: 0,
    },
  };

  const list = ref({ ...defaultObject });

  const sumProgressItems = computed(() => {
    return Object.keys(list.value).reduce(
      (sum, key) => sum + parseFloat(list.value[key].count || 0),
      0
    );
  });
  const getProgressItemWidth = (value: number) => {
    return ((value / sumProgressItems.value) * 100).toFixed(4) + "%";
  };
  const setLotStatusCount = () => {
    props.statusCounts.forEach(({ count, status }) => {
      const statusKey = status as keyof typeof list.value;

      if (list.value[statusKey]) {
        list.value[statusKey].count = count || 0;
      }
    });
  };

  watch(
    () => props.statusCounts,
    () => {
      list.value = JSON.parse(JSON.stringify(defaultObject));

      if (!props.statusCounts) {
        return;
      }

      setLotStatusCount();
    },
    { deep: true, immediate: true }
  );

const __returned__ = { props, defaultObject, list, sumProgressItems, getProgressItemWidth, setLotStatusCount, get CounterStatusItem() { return CounterStatusItem }, get LotStatus() { return LotStatus }, computed, ref, watch }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})